import "core-js/modules/es.array.reverse.js";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import ChartableMixin, { axesMatch } from "../ModelMixins/ChartableMixin";
/**
 * Derives a consistent view of chart data from all the chartable items in the
 * workbench.
 */
let ChartView = (_class = class ChartView {
  constructor(terria) {
    this.terria = terria;
    makeObservable(this);
  }
  get chartableItems() {
    return this.terria.workbench.items.filter(item => ChartableMixin.isMixedInto(item) && item.chartItems.length > 0);
  }

  /**
   * Returns the common x-axis for the chart.
   */
  get xAxis() {
    // We just return the xAxis of the first chartItem selected in the workbench.
    for (let i = 0; i < this.chartableItems.length; i++) {
      for (let j = 0; j < this.chartableItems[i].chartItems.length; j++) {
        const chartItem = this.chartableItems[i].chartItems[j];
        if (chartItem.isSelectedInWorkbench && chartItem.showInChartPanel) {
          return chartItem.xAxis;
        }
      }
    }
    return undefined;
  }

  /**
   * Returns chartItems for all chartable items in the workbench.
   *
   * Sets flags for how the chart items are displayed in the workbench and
   * in the chart panel.
   */
  get chartItems() {
    return this.chartableItems.reduce((acc, item) => {
      return acc.concat(item.chartItems.map(chartItem => {
        if (this.xAxis && !axesMatch(this.xAxis, chartItem.xAxis)) {
          chartItem = _objectSpread(_objectSpread({}, chartItem), {}, {
            isSelectedInWorkbench: false,
            showInChartPanel: false
          });
        }
        return chartItem;
      }));
    }, []);
  }
}, _applyDecoratedDescriptor(_class.prototype, "chartableItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "chartableItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xAxis", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "xAxis"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "chartItems"), _class.prototype), _class);
export { ChartView as default };